import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * Focuses the host element once it is rendered, placing the caret at the end for text inputs.
 * Used by the extracted-notes inline editor so click-outside / Esc cancel work as soon as
 * the textarea appears.
 */
@Directive({
  selector: '[appAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const element = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement;
    // Defer to the next tick so the element is laid out before we focus it.
    setTimeout(() => {
      element.focus();
      const value = element.value ?? '';
      if (typeof element.selectionStart === 'number') {
        element.selectionStart = element.selectionEnd = value.length;
      }
    });
  }
}
